import React from "react";
import { NavLink } from "reactstrap";
import { useNavigate } from "react-router-dom";
import userManager from "../auth/oidcConfig"; // Adjust the path as needed
import { authenticatedPost } from "../utils/apiUtils";

const Logout = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      // First, invalidate the encryption session
      try {
        await authenticatedPost("/encryption/invalidate-session", {});
        console.log("Encryption session invalidated");
      } catch (error) {
        // Don't prevent logout if session invalidation fails
        console.warn("Failed to invalidate encryption session:", error);
      }

      // Then proceed with the normal logout
      await userManager.signoutRedirect();
      navigate("/"); // Redirect to the home page or any page after logout
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  return (
    <NavLink
      href="#"
      onClick={handleLogout}
      className="text-white"
      style={{ cursor: "pointer" }}
    >
      Logout
    </NavLink>
  );
};

export default Logout;
